<template>
  <div class="content has-text-left">
    <h4
      class="is-size-6 has-text-danger"
      :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
    >* {{ $t('banners_ad_blocker_notice') }}</h4>
    <br />

    <div v-if="trackingCode !== ''">
      <template v-for="banner in banners">
        <h4
          :key="banner.name"
          :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
        >{{ banner.name }}</h4>
        <div
          id="banners"
          :key="'banner-' + banner.name"
          :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
        >
          <div class="tile is-ancestor bannerGroup">
            <div class="tile is-vertical is-12">

              <div
                class="tile"
                v-if="banner.images['150x70-dark']"
              >
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <figure class="image">
                      <img
                        :src="imageBaseURL + banner.images['150x70-dark']"
                        style="width:150px; height: 70px"
                      />
                    </figure>
                    <div class="content">
                      <textarea>{{ `<a href="${trackURL + trackingCode}"><img src="${imageBaseURL + banner.images['150x70-dark']}"></a>` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="returnHTMLCode(imageBaseURL + banner.images['150x70-dark'])"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <figure class="image">
                      <img
                        :src="imageBaseURL + banner.images['180x60-dark']"
                        style="width:180px; height: 60px"
                      />
                    </figure>
                    <div class="content">
                      <textarea style="height:102px">{{ `<a href="${trackURL + trackingCode}"><img src="${imageBaseURL + banner.images['180x60-dark']}"></a>` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="returnHTMLCode(imageBaseURL + banner.images['180x60-dark'])"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
              </div>

              <div
                class="tile"
                v-if="banner.images['150x70-dark']"
              >

                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <figure class="image">
                      <img
                        :src="imageBaseURL + banner.images['400x234-dark']"
                        style="width:400px; height: 234px"
                      />
                    </figure>
                    <div class="content">
                      <textarea style="height:102px">{{ `<a href="${trackURL + trackingCode}"><img src="${imageBaseURL + banner.images['400x234-dark']}"></a>` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="returnHTMLCode(imageBaseURL + banner.images['400x234-dark'])"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <figure class="image">
                      <img
                        :src="imageBaseURL + banner.images['512x256-dark']"
                        style="width:512px; height: 256px"
                      />
                    </figure>
                    <div class="content">
                      <textarea style="height:102px">{{ `<a href="${trackURL + trackingCode}"><img src="${imageBaseURL + banner.images['512x256-dark']}"></a>` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="returnHTMLCode(imageBaseURL + banner.images['512x256-dark'])"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
              </div>

              <div
                class="tile"
                v-if="banner.images['150x70-purple']"
              >

                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <figure class="image">
                      <img
                        :src="imageBaseURL + banner.images['150x70-purple']"
                        style="width:150px; height: 70px"
                      />
                    </figure>
                    <div class="content">
                      <textarea>{{ `<a href="${trackURL + trackingCode}"><img src="${imageBaseURL + banner.images['150x70-purple']}"></a>` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="returnHTMLCode(imageBaseURL + banner.images['150x70-purple'])"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <figure class="image">
                      <img
                        :src="imageBaseURL + banner.images['180x60-purple']"
                        style="width:180px; height: 60px"
                      />
                    </figure>
                    <div class="content">
                      <textarea style="height:102px">{{ `<a href="${trackURL + trackingCode}"><img src="${imageBaseURL + banner.images['180x60-purple']}"></a>` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="returnHTMLCode(imageBaseURL + banner.images['180x60-purple'])"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
              </div>

              <div
                class="tile"
                v-if="banner.images['150x70-purple']"
              >

                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <figure class="image">
                      <img
                        :src="imageBaseURL + banner.images['400x234-purple']"
                        style="width:400px; height: 234px"
                      />
                    </figure>
                    <div class="content">
                      <textarea style="height:102px">{{ `<a href="${trackURL + trackingCode}"><img src="${imageBaseURL + banner.images['400x234-purple']}"></a>` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="returnHTMLCode(imageBaseURL + banner.images['400x234-purple'])"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <figure class="image">
                      <img
                        :src="imageBaseURL + banner.images['512x256-purple']"
                        style="width:512px; height: 256px"
                      />
                    </figure>
                    <div class="content">
                      <textarea style="height:102px">{{ `<a href="${trackURL + trackingCode}"><img src="${imageBaseURL + banner.images['512x256-purple']}"></a>` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="returnHTMLCode(imageBaseURL + banner.images['512x256-purple'])"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
              </div>

              <div
                class="tile"
                v-if="banner.images['300x600']"
              >
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <figure class="image">
                      <img
                        :src="imageBaseURL + banner.images['300x600']"
                        class="i336"
                      />
                    </figure>
                    <div class="content">
                      <textarea>{{ `<a href="${trackURL + trackingCode}"><img src="${imageBaseURL + banner.images['300x600']}"></a>` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="returnHTMLCode(imageBaseURL + banner.images['300x600'])"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
              </div>

              <div class="tile">
                <div
                  class="tile is-parent"
                  v-if="banner.images['160x600']"
                >
                  <article class="tile is-child notification">
                    <figure class="image">
                      <img
                        :src="imageBaseURL + banner.images['160x600']"
                        style="width:160px; height: 600px"
                      />
                    </figure>
                    <div class="content">
                      <textarea>{{ `<a href="${trackURL + trackingCode}"><img src="${imageBaseURL + banner.images['160x600']}"></a>` }}</textarea>
                      <button
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        class="button is-success"
                        type="button"
                        v-clipboard:copy="returnHTMLCode(imageBaseURL + banner.images['160x600'])"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>

                <div
                  class="tile is-parent"
                  v-if="banner.images['300x250']"
                >
                  <article class="tile is-child notification">
                    <figure class="image">
                      <img
                        :src="imageBaseURL + banner.images['300x250']"
                        class="i300"
                      />
                    </figure>
                    <div class="content">
                      <textarea>{{ `<a href="${trackURL + trackingCode}"><img src="${imageBaseURL + banner.images['300x250']}"></a>` }}</textarea>
                      <button
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        class="button is-success"
                        type="button"
                        v-clipboard:copy="returnHTMLCode(imageBaseURL + banner.images['300x250'])"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
              </div>
              <div
                class="tile is-parent"
                v-if="banner.images['970x250']"
              >
                <article class="tile is-child notification">
                  <div class="content">
                    <figure class="image">
                      <img
                        :src="imageBaseURL + banner.images['970x250']"
                        class="i970"
                      />
                    </figure>
                  </div>
                  <div class="content">
                    <textarea>{{ `<a href="${trackURL + trackingCode}"><img src="${imageBaseURL + banner.images['970x250']}"></a>` }}</textarea>
                    <button
                      class="button is-success is-pulled-right"
                      type="button"
                      v-clipboard:copy="returnHTMLCode(imageBaseURL + banner.images['970x250'])"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >Copy</button>
                  </div>
                </article>
              </div>
              <div
                class="tile is-parent"
                v-if="banner.images['728x90']"
              >
                <article class="tile is-child notification">
                  <div class="content">
                    <figure class="image">
                      <img
                        :src="imageBaseURL + banner.images['728x90']"
                        class="i728"
                      />
                    </figure>
                  </div>
                  <div class="content">
                    <textarea>{{ `<a href="${trackURL + trackingCode}"><img src="${imageBaseURL + banner.images['728x90']}"></a>` }}</textarea>
                    <button
                      :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                      class="button is-success"
                      type="button"
                      v-clipboard:copy="returnHTMLCode(imageBaseURL + banner.images['728x90'])"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >{{$t('copy')}}</button>
                  </div>
                </article>
              </div>
              <div
                class="tile"
                v-if="banner.images['600x200']"
              >
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <figure class="image">
                      <img
                        :src="imageBaseURL + banner.images['600x200']"
                        style="height:200px;width:600px;object-fit:contain"
                      />
                    </figure>
                    <div class="content">
                      <textarea style="height:102px">{{ `<a href="${trackURL + trackingCode}"><img src="${imageBaseURL + banner.images['600x200']}"></a>` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="returnHTMLCode(imageBaseURL + banner.images['600x200'])"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <figure class="image">
                      <img
                        :src="imageBaseURL + banner.images['1200x900']"
                        style="width:1200px;object-fit:contain"
                      />
                    </figure>
                    <div class="content">
                      <textarea style="height:102px">{{ `<a href="${trackURL + trackingCode}"><img src="${imageBaseURL + banner.images['1200x900']}"></a>` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="returnHTMLCode(imageBaseURL + banner.images['1200x900'])"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
              </div>
              <div
                class="tile"
                v-if="banner.images['1200x630']"
              >
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <figure class="image">
                      <img :src="imageBaseURL + banner.images['1200x630']" />
                    </figure>
                    <div class="content">
                      <textarea>{{ `<a href="${trackURL + trackingCode}"><img src="${imageBaseURL + banner.images['1200x630']}"></a>` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="returnHTMLCode(imageBaseURL + banner.images['1200x630'])"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
              </div>
              <div
                class="tile"
                v-if="banner.images['150x150']"
              >
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <figure class="image">
                      <img
                        :src="imageBaseURL + banner.images['150x150']"
                        style="height:150px;width:150px;object-fit:contain"
                      />
                    </figure>
                    <div class="content">
                      <textarea style="height:102px">{{ `<a href="${trackURL + trackingCode}"><img src="${imageBaseURL + banner.images['150x150']}"></a>` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="returnHTMLCode(imageBaseURL + banner.images['150x150'])"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <figure class="image">
                      <img
                        :src="imageBaseURL + banner.images['300x158']"
                        style="height:158px;width:300px;object-fit:contain"
                      />
                    </figure>
                    <div class="content">
                      <textarea style="height:102px">{{ `<a href="${trackURL + trackingCode}"><img src="${imageBaseURL + banner.images['300x158']}"></a>` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="returnHTMLCode(imageBaseURL + banner.images['300x158'])"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
              </div>
              <div
                class="tile"
                v-if="banner.images['768x403']"
              >
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <figure class="image">
                      <img
                        :src="imageBaseURL + banner.images['768x403']"
                        style="width:768px;object-fit:contain"
                      />
                    </figure>
                    <div class="content">
                      <textarea style="height:102px">{{ `<a href="${trackURL + trackingCode}"><img src="${imageBaseURL + banner.images['768x403']}"></a>` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="returnHTMLCode(imageBaseURL + banner.images['768x403'])"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <figure class="image">
                      <img
                        :src="imageBaseURL + banner.images['1024x538']"
                        style="width:1024px;object-fit:contain"
                      />
                    </figure>
                    <div class="content">
                      <textarea style="height:102px">{{ `<a href="${trackURL + trackingCode}"><img src="${imageBaseURL + banner.images['1024x538']}"></a>` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="returnHTMLCode(imageBaseURL + banner.images['1024x538'])"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
              </div>
              <div
                class="tile"
                v-if="banner.images['560x315']"
              >
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <figure class="image">
                      <iframe
                        width="560"
                        height="315"
                        :src="banner.images['560x315']"
                        title="Eurotrader in 60 seconds"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      ></iframe>
                    </figure>
                    <div class="content">
                      <textarea style="height:102px">{{ `<iframe width="560" height="315" src="${banner.images['560x315']}" title="Eurotrader in 60 seconds" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="returnEmbedCode(banner.images['560x315'],560,315,'Eurotrader in 60 seconds')"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
              </div>
              <div
                class="tile"
                v-if="banner.images['home']"
              >

                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <div class="content">

                      <p style="margin:0"><b>Home page</b></p>
                      <textarea>{{ `${trackURL + trackingCode}&dest=${banner.images['home']}` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="`${trackURL + trackingCode}&dest=${banner.images['home']}`"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <div class="content">

                      <p style="margin:0"><b>Spreads &amp; Swaps</b></p>
                      <textarea>{{ `${trackURL + trackingCode}&dest=${banner.images['spreads']}` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="`${trackURL + trackingCode}&dest=${banner.images['spreads']}`"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
              </div>
              <div
                class="tile"
                v-if="banner.images['mt4']"
              >

                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <div class="content">

                      <p style="margin:0"><b>MT4 info</b></p>
                      <textarea>{{ `${trackURL + trackingCode}&dest=${banner.images['mt4']}` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="`${trackURL + trackingCode}&dest=${banner.images['mt4']}`"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <div class="content">

                      <p style="margin:0"><b>MT5 info</b></p>
                      <textarea>{{ `${trackURL + trackingCode}&dest=${banner.images['mt5']}` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="`${trackURL + trackingCode}&dest=${banner.images['mt5']}`"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
              </div>
              <div
                class="tile"
                v-if="banner.images['accountTypes']"
              >

                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <div class="content">

                      <p style="margin:0"><b>Account types &amp; Deposit methods</b></p>
                      <textarea>{{ `${trackURL + trackingCode}&dest=${banner.images['accountTypes']}` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="`${trackURL + trackingCode}&dest=${banner.images['accountTypes']}`"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <div class="content">

                      <p style="margin:0"><b>Contact Us page</b></p>
                      <textarea>{{ `${trackURL + trackingCode}&dest=${banner.images['contact']}` }}</textarea>
                      <button
                        class="button is-success"
                        :class="{'is-pulled-left': Language == 'fa' || Language == 'ar', 'is-pulled-right': Language != 'fa' && Language != 'ar'}"
                        type="button"
                        v-clipboard:copy="`${trackURL + trackingCode}&dest=${banner.images['contact']}`"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >{{$t('copy')}}</button>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import config from '../../config'
import { service } from '../../app'

export default {
  data() {
    return {
      message: '',
      imageBaseURL: config.URL.marketingMaterial,
      trackURL: config.URL.track,
      trackingCode: '',
      banners: [
        {
          name: 'Logo',
          images: {
            '150x70-dark': 'eurotrader-logo-dark.png',
            '180x60-dark': 'eurotrader-logo-dark-180x60.png',
            '400x234-dark': 'eurotrader-logo-dark-400x234.png',
            '512x256-dark': 'eurotrader-logo-dark-512x256.png',
            '150x70-purple': 'eurotrader-logo-purple.png',
            '180x60-purple': 'eurotrader-logo-purple-180x60.png',
            '400x234-purple': 'eurotrader-logo-purple-400x234.png',
            '512x256-purple': 'eurotrader-logo-purple-512x256.png',
          },
        },
        {
          name: '1',
          images: {
            '160x600': '0a-160-600.png',
            '300x250': '0a-300-250.png',
            '300x600': '0a-300-600.png',
            '728x90': '0a-728-90.png',
            '970x250': '0a-970-250.png',
          },
        },
        {
          name: '2',
          images: {
            '160x600': '0b-160-600.png',
            '300x250': '0b-300-250.png',
            '300x600': '0b-300-600.png',
            '728x90': '0b-728-90.png',
            '970x250': '0b-970-250.png',
          },
        },
        {
          name: '3',
          images: {
            '160x600': '0c-160-600.png',
            '300x250': '0c-300-250.png',
            '300x600': '0c-300-600.png',
            '728x90': '0c-728-90.png',
            '970x250': '0c-970-250.png',
          },
        },
        {
          name: '4',
          images: {
            '300x250': 'eurotrader-newsletter-banner-pink-300x250.png',
            '600x200': 'eurotrader-newsletter-banner-pink-600x200.png',
            '1200x900': 'eurotrader-newsletter-banner-pink-1200x900.png',
          },
        },
        {
          name: '5',
          images: {
            '300x250': 'eurotrader-newsletter-banner-purple-300x250.png',
            '600x200': 'eurotrader-newsletter-banner-purple-600x200.png',
            '1200x900': 'eurotrader-newsletter-banner-purple-1200x900.png',
          },
        },
        {
          name: '6',
          images: {
            '150x150': 'eurotrader-meta-image-150x150.png',
            '300x158': 'eurotrader-meta-image-300x158.png',
            '768x403': 'eurotrader-meta-image-768x403.png',
            '1024x538': 'eurotrader-meta-image-1024x538.png',
            '1200x630': 'eurotrader-meta-image.png',
          },
        },
        {
          name: '7',
          images: {
            '560x315': 'https://www.youtube.com/embed/tTEXZf_zZQk',
          },
        },
        {
          name: '8',
          images: {
            home: 'home',
            spreads: 'spreads',
            mt4: 'mt4',
            mt5: 'mt5',
            accountTypes: 'accountTypes',
            contact: 'contact',
          },
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
    }),
  },
  mounted() {
    // get IB overview info
    if (!Object.keys(this.User.IB).length || !this.User.IB.tracking_links || !Object.keys(this.User.IB.tracking_links).length) {
      this['logoLoader/set'](true)
      service
        .get('/ib/' + this.User.info.ID)
        .then(response => {
          this['user/setIB'](response.data)
          this['logoLoader/set'](false)
          this.trackingCode = Object.values(this.User.IB.tracking_links)[0]
        })
        .catch(() => {
          this['logoLoader/set'](false)
        })
    } else {
      this.trackingCode = Object.values(this.User.IB.tracking_links)[0]
    }
  },
  methods: {
    returnHTMLCode(text) {
      return '<a href="' + this.trackURL + this.trackingCode + '"><img src="' + text + '"></a>'
    },
    returnEmbedCode(text, width, height, title) {
      return (
        ' <iframe width="' +
        width +
        '" height="' +
        height +
        '" src="' +
        text +
        '" title="' +
        title +
        '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
      )
    },
    onCopy: function (e) {
      this.$toasted.success(this.$t('copied_text_successfully', { text: '<strong>' + this.$escapeHtml(e.text) + '</strong>' }))
      // alert('You just copied: ' + e.text)
    },
    onError: function (e) {
      alert('Failed to copy text')
    },
    ...mapActions(['user/setIB', 'logoLoader/set']),
  },
}
</script>

<style lang="scss" scoped>
#banners {
  padding-bottom: 2em;
  border-bottom: 1px solid #000;
  margin-bottom: 1em;

  .bannerGroup {
    border: 1px solid #e6e6e6;
    article {
      border: 1px solid #e6e6e6;
    }
  }
  img.i336 {
    max-width: 336px;
    margin: 0 auto;
  }
  img.i300 {
    max-width: 300px;
    margin: 0 auto;
  }
  img.i728 {
    max-width: 728px;
    margin: 0 auto;
  }
  img.i468 {
    max-width: 468px;
    margin: 0 auto;
  }
  .content textarea {
    padding: 20px;
    width: 100%;
    height: 70px;
    margin: 10px 0 0;
    outline: none;
    background-color: #f0f0f0;
    border: 1px solid #e6e6e6;
    resize: none;
  }
}
</style>



// WEBPACK FOOTER //
// MarketingMaterial.vue?9cd106a0